function AppContainer({ children }) {
    return (
        <div
            style={{
                maxWidth: '100%',
                padding: '20px',
                margin: '0 auto',
                display: 'flex',
                justifyContent: 'center', // centraliza horizontalmente
            }}
        >
            <div style={{
                width: '100%',
                maxWidth: '500px', // para mobile, e se quiser pode aumentar para desktop via media query
            }}>
                {children}
            </div>
        </div>
    );
}

export default AppContainer;
